import { Attendance, PunchesData } from "../../domains/models/attendance/attendance";
import dayjs from 'dayjs';
import Locale from "../../core/locale/locale";
import { removeUnderScore, removeUnderScoreWithLowerCase } from "../../utility/utility";
import { IEmpAttendanceData } from "./attendance.types";


export function mapPunchData(res: PunchesData[]) {

    return res.map((punch) => {
        const dateTime=`${punch.date}T${punch.time}`
        const status = removeUnderScoreWithLowerCase(punch.type).toLowerCase();
        return {
            id: punch.id,
            time: formatPunchTime(dateTime),
            status: status
        }

    });
}



export function mapCalendarEvent(attendance: Attendance[]) {
  return attendance.map((item)=>(
      {
          id: item.id,
          title: "",
          start: dayjs(item.date).toDate(),
          end: dayjs(item.date).toDate(),
          allDay: true,
          attendance:{
              date:item.date,
              status:item.status
          }
      }
  ))
}


export function formatPunchTime(dateTime:string){
   return dayjs
        .utc(dateTime)
        .tz(dayjs.tz.guess())
        .format(Locale.displayTimeShort);
}
function getWorkingHoursFormat(time?: string): string {
    if (!time) return "--";

    const [hours, minutes] = time.split(":").map(Number);

    if (hours === 0 && minutes === 0) {
        return "0 min";
    }

    if (hours === 0) {
        return `${minutes} min`;
    }

    if (minutes === 0) {
        return `${hours}h`;
    }

    return `${hours}h ${minutes} min`;
}
export function mapEmpAttendanceData(attendance: Attendance[], punches: PunchesData[]): IEmpAttendanceData[] {
    return attendance.map((item) => {
        const checkInDateTime=`${item.date}T${item.checkInTime}`;
        const checkOutDateTime=`${item.date}T${item.checkInTime}`

        return {
            id: item.id,
            date: item.date,
            status: item.status,
            checkInTime:item.checkInTime?formatPunchTime(checkInDateTime):'--:--',
            checkOutTime:item.checkOutTime?formatPunchTime(checkOutDateTime):'--:--',
            workingHours:getWorkingHoursFormat(item.workingHours),
            punches: filterPunchesByDate(item.date, punches)
        }
    })
}

function filterPunchesByDate(date: string, punches: PunchesData[]) {
    return punches
        .filter((item) => item.date === date)
        .map((item) => {
            const dateTime=`${item.date}T${item.time}`;
            return {
            id:item.id,
            time: item.time?formatPunchTime(dateTime):'--:--',
            type: removeUnderScore(item.type),
        }});

}


export function scrollToAttendanceTable() {
    const element = document.getElementById("pn-attendance-table");

    element?.scrollIntoView({
        behavior: "smooth",
    });
}
